<div class="subpage-container">
	<div class="form-container">
		<app-address-with-search [formGroup]="form" [infoPopOver]="infoPopOver"></app-address-with-search>
	</div>
</div>
